import * as authenticationMSEntra from './authenticationMSEntra'
import * as authenticationOidc from './authenticationOidc'

let authenticationModule: any

const setAuthenticationModule = (useMSEntra: boolean) => {
  if (useMSEntra) {
    authenticationModule = authenticationMSEntra
    return
  }
  authenticationModule = authenticationOidc
}

export const auth = {
  init: async (config: any, useMSEntra: boolean) => {
    setAuthenticationModule(useMSEntra)
    await authenticationModule.init(config)
  },
  useAuthentication: () => authenticationModule.useAuthentication()
}
